import styled from 'styled-components';
import { TypographyStyles, WhiteButton, colours, media, spacing } from '@storefront/lib-global';

export const ProductListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProductListContainer = styled.div`
  column-gap: ${spacing.XXXS};
  display: grid;
  grid-template-columns: repeat(2, minmax(100px, 1fr));
  padding-bottom: ${spacing.M};
  row-gap: ${spacing.M};
  @media ${media.greaterThan('lg')} {
    column-gap: ${spacing.M};
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    padding-bottom: 60px;
    row-gap: 60px;
  }
`;

export const ContentBannerWrapper = styled.div<{ position: number }>`
  grid-column: 1 / span 2;
  grid-row-start: ${({ position }) => position};

  @media ${media.greaterThan('lg')} {
    grid-column: 1 / span 3;
  }
`;

export const CategoryHero = styled.div`
  display: none;
  @media ${media.greaterThan('lg')} {
    align-items: center;
    background-color: ${colours.LIGHT_BLUE};
    display: flex;
    flex-direction: column;
    grid-column: 1 / span 3;
    justify-content: center;
    margin-bottom: 60px;
    padding: 40px;
  }
`;

export const CategoryName = styled.h1`
  ${TypographyStyles.Headings.H3}
  margin: 0 0 48px;
  text-transform: uppercase;
`;

export const PageDetail = styled.div`
  ${TypographyStyles.Body.Tiny.Regular}
  align-content: center;
  color: ${colours.GREY};
  display: flex;
  justify-content: center;
  padding: 0px ${spacing.S} ${spacing.XXS} ${spacing.S};
`;

export const StyledWhiteButton = styled(WhiteButton)`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXS};
  justify-content: center;
  padding: 0px;
  @media ${media.greaterThan('lg')} {
    align-self: center;
    width: 300px;
  }
`;
